import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "./styles";


const ArabicComponent = ({arabText,textColor='black',textBreak=false, textStyle, componentStyle }) => {
  return (
<View style={[styles.flexRowReverse, styles.flexWrap, componentStyle]}>
{
    getFormattedArabic(arabText)?.map((word, idx) => {
        return (
            <Text style={[styles.arabic,{color:textColor},textStyle]} key={idx} break={textBreak}>
            {word + " "}
            </Text>
        );
    })
}
</View>
  )
}

export default ArabicComponent



function getFormattedArabic (text){
  // text = text?.replace(/(\d+)/g, '$1 ');
  text = text?.replace(/([^\d-])(?=\d)|(?<=\d)([^\d-])/g, '$1 $2');

  const modifiedText = text?.replace(/[\(\)]/g, match => (match === '(' ? ') ' : '('));
  const modifiedText2 = modifiedText?.replace(/[\<\>]/g, match => (match === '<' ? '> ' : '<'));
  return modifiedText2?.split(' ');    
}